<template>
    <div class="hot-course-container">
        <h1 style="display: flex;">热门课程</h1>

        <!-- 左右布局 -->
        <div class="layout">
            <!-- 左侧课程列表 -->
            <div class="course-list-container" :style="{ height: 560 + 'px' }">
                <ul class="course-list">
                    <li v-for="(item, index) in courses" :key="item.id" :class="{ active: activeIndex === index }"
                        @mouseenter="handleCourseHover(index)" @click="handleCourseClick(item)">
                        <span class="course-name">{{ item.coursename }}</span>
                        <span v-if="activeIndex === index" class="active-indicator">▶</span>
                    </li>
                </ul>
            </div>

            <!-- 中间轮播图 -->
            <div class="carousel-container" :style="{ height: 560 + 'px' }">
                <el-carousel indicator-position="none" :interval="5000" arrow="always" :height="560 + 'px'"
                    ref="carouselRef" @change="handleCarouselChange">
                    <el-carousel-item v-for="item in courses" :key="item.id" @click="handleCourseClick(item)">
                        <div class="course-card">
                            <div class="image-container">
                                <img :src="item.cover || defaultCover" alt="course cover" class="course-cover" />
                                <div class="text-overlay">
                                    <h3>{{ item.coursename }}</h3>
                                    <p style="text-align: left;">{{ item.description }}</p>
                                </div>
                            </div>
                        </div>
                    </el-carousel-item>
                </el-carousel>
            </div>

            <!-- 右侧用户信息 -->
            <!-- <div  v-if="!isTablet || !localStorageUser" class="user-info-container" :style="{ height: 560 + 'px' }">
                <div class="user-info">
                    <h3 v-if="!localStorageUser">立即免费解锁外语</h3>
                    <h3 v-else>名称：{{ localStorageUser.username }}</h3>
                    <p v-if="!localStorageUser">优质课程</p>
                    <el-avatar v-if="!localStorageUser" :size="80" icon="el-icon-user" />
                    <el-avatar v-else :size="80" :src="localStorageUser.useravatar" />
                    <div v-if="!localStorageUser">
                        <el-button type="primary" @click="showLoginDialog">立即登录</el-button>
                    </div>
                    <div v-else>
                        <el-button type="primary" @click="goto_usercenter">个人中心</el-button>
                        <el-button type="primary" @click="login_out">退出登录</el-button>
                    </div>
                </div>
            </div> -->
        </div>

        <!-- 登录弹窗组件 -->
        <LoginDialogComponent v-model:visible="showLogin" @login-success="handleLoginSuccess" />
    </div>
</template>

<script setup lang="ts">
import { ref, onMounted, nextTick } from 'vue';
import { contentService } from '@/services/ContentService';
import { GetCourseByTypeRequest } from '@/types/course/request/GetCourseByTypeRequest';
import { UserInfo } from '@/types/user/UserInfo'
import { ElCarousel, ElCarouselItem, ElAvatar, ElButton } from 'element-plus';
import 'element-plus/es/components/carousel/style/css';
import 'element-plus/es/components/avatar/style/css';
import 'element-plus/es/components/button/style/css';
import LoginDialogComponent from '@/components/home/LoginDialogComponent.vue';
import { Course } from '@/types/course/request/Course';
import router from "@/router/index"
import { ElMessage } from 'element-plus';
// 定义请求参数
const getCourseByTypeRequest = ref<GetCourseByTypeRequest>({
    status: 1,
    limit: 10, // 固定 10 条数据
    page: 1,
});

// 定义课程数据
const courses = ref<Course[]>();

// 默认封面图片
const defaultCover = ref('https://via.placeholder.com/300x150?text=No+Cover');

// 当前激活的课程索引
const activeIndex = ref(0);

// 获取轮播图实例
const carouselRef = ref<InstanceType<typeof ElCarousel>>();

// 左侧课程列表高度
const listHeight = ref(0);

// 用户信息
const localStorageUser = ref<UserInfo>();

// 控制登录弹窗显示
const showLogin = ref(false);
// 判断是否为平板端
const isTablet = ref(false);


// 在组件挂载时调用方法
onMounted(async () => {
    const storedUserInfo = localStorage.getItem('user');
    if (storedUserInfo) {
        localStorageUser.value = JSON.parse(storedUserInfo);
    }

     // 检测设备是否为平板端
    checkIfTablet();

    try {
        const response = await contentService.get_courses_by_type(getCourseByTypeRequest.value);
        courses.value = response.data.courses;

        // 等待 DOM 更新完成后计算高度
        nextTick(() => {
            calculateListHeight();
        });
    } catch (error) {
        console.error('获取课程数据失败:', error);
    }
});

// 检测设备是否为平板端
const checkIfTablet = () => {
    const width = window.innerWidth;
    isTablet.value = width >= 769 && width <= 1024;
};


// 计算左侧课程列表高度
const calculateListHeight = () => {
    const liElement = document.querySelector('.course-list li');
    if (liElement) {
        const liHeight = liElement.clientHeight; // 获取单个 <li> 的高度
        const padding = 10; // 假设每个 <li> 之间有 10px 的间距
        listHeight.value = (liHeight + padding) * 10; // 10 个 <li> 的总高度
    }
    console.log("高度：" + listHeight.value)
};

// 鼠标移入课程列表项时触发
const handleCourseHover = (index: number) => {
    activeIndex.value = index; // 更新高亮项
    if (carouselRef.value) {
        carouselRef.value.setActiveItem(index); // 切换轮播图
    }
};

// 点击课程列表项时切换轮播图
const handleCourseClick = (course: Course) => {
    
        router.push({
            name: 'information',
            params: { courseId: String(course.id) } // 仅传递 course 的 id
        });
    
};

// 轮播图切换时更新高亮项
const handleCarouselChange = (currentIndex: number) => {
    activeIndex.value = currentIndex;
};

// 跳转到个人中心
const goto_usercenter = () => {
    console.log('跳转到个人中心');
     router.push({
        name: 'personalCenter'
    });
};

// 退出登录
const login_out = () => {
    console.log('退出登录');
    // 清除 token
    localStorage.removeItem('token');
    // 清除 user 信息
    localStorage.removeItem('user');
    localStorageUser.value = undefined;
    ElMessage.success("退出登录成功！")
};

// 显示登录弹窗
const showLoginDialog = () => {
    showLogin.value = true;
};

// 处理登录成功事件
const handleLoginSuccess = (userInfo: UserInfo) => {
     
    localStorage.setItem('user', JSON.stringify(userInfo));
    localStorageUser.value = userInfo;
    showLogin.value = false;
    ElMessage({
        message: '登录成功',
        type: 'success',
        duration: 2000, // 设置为 0，表示提示不会自动关闭
    });
};
</script>

<style scoped>
/* 容器样式 */
.hot-course-container {
    padding: 20px;
}

/* 左右布局 */
.layout {
    display: flex;
    gap: 20px;
    /* 课程列表、轮播图和用户信息之间的间距 */
}

/* 左侧课程列表 */
.course-list-container {
    flex: 1;
    /* 课程列表占 1 份 */
    max-width: 300px;
    /* 限制课程列表的最大宽度 */
    border: 1px  #e0e0e0;
    /* 最外层细边框 */
    border-radius: 8px;
    /* 圆角 */
    /* box-shadow: 0 2px 8px rgba(0, 0, 0, 0.1); */
    /* 阴影效果 */
    padding: 10px;
    /* 内边距 */
    background-color: #fff;
    /* 背景色 */
    overflow-y: auto;
    /* 如果内容超出高度，显示滚动条 */
}

/* 课程列表样式 */
.course-list {
    list-style: none;
    padding: 0;
    margin: 0;
}

.course-list li {
    padding: 12px 16px;
    /* 内边距 */
    margin: 5px 0;
    /* 每个 <li> 之间的间距 */
    cursor: pointer;
    transition: background-color 0.3s ease, color 0.3s ease;
    display: flex;
    justify-content: space-between;
    align-items: center;
}

.course-list li:hover {
    background-color: #f5f5f5;
    /* 悬停背景色 */
}

.course-list li.active {
    background-color: #409eff;
    /* 激活背景色 */
    color: white;
    /* 激活文字颜色 */
}

.course-list li.active .course-name {
    font-weight: bold;
    /* 激活项文字加粗 */
}

.course-list li.active .active-indicator {
    display: inline-block;
    /* 显示激活指示器 */
}

.course-list li .active-indicator {
    display: none;
    /* 默认隐藏激活指示器 */
    font-size: 14px;
}

/* 中间轮播图 */
.carousel-container {
    flex: 3;
    /* 轮播图占 3 份 */
}

/* 轮播图样式 */
.course-card {
    text-align: center;
    padding: 20px;
    border-radius: 8px;
    background-color: #f9f9f9;
    height: 100%;
    display: flex;
    justify-content: center;
    align-items: center;
}

.image-container {
    position: relative;
    width: 100%;
    height: 100%;
}

.course-cover {
    width: 100%;
    height: 100%;
    object-fit: cover;
    border-radius: 8px;
    pointer-events: none;
    /* 禁用图片的点击事件 */
}

/* 文字覆盖层 */
.text-overlay {
    position: absolute;
    bottom: 0;
    left: 0;
    right: 0;
    background-color: rgba(0, 0, 0, 0.6);
    /* 黑色背景，透明度 60% */
    color: white;
    padding: 20px;
    border-radius: 0 0 8px 8px;
}

.text-overlay h3 {
    margin: 0;
    font-size: 1.5rem;
}

.text-overlay p {
    margin: 5px 0 0;
    font-size: 1rem;
    opacity: 0.9;
    /* 文字透明度 */
}

/* 右侧用户信息 */
.user-info-container {
    flex: 1;
    /* 用户信息占 1 份 */
    max-width: 250px;
    /* 限制用户信息的最大宽度 */
    border: 1px solid #e0e0e0;
    /* 最外层细边框 */
    border-radius: 8px;
    /* 圆角 */
    box-shadow: 0 2px 8px rgba(0, 0, 0, 0.1);
    /* 阴影效果 */
    padding: 20px;
    /* 内边距 */
    background-color: #fff;
    /* 背景色 */
    display: flex;
    justify-content: center;
    align-items: center;
}

.user-info {
    text-align: center;
}

.user-info h3 {
    margin: 0 0 10px;
    font-size: 1.2rem;
}

.user-info p {
    margin: 0 0 20px;
    font-size: 0.9rem;
    color: #666;
}

.user-info .el-avatar {
    margin-bottom: 20px;
}

.user-info .el-button {
    margin: 5px 0;
    width: 100%;
}

/* 响应式布局 */
@media (max-width: 768px) {

    /* 手机端 */
    .course-list-container {
        display: none;
        /* 隐藏左侧课程列表 */
    }

    .carousel-container {
        flex: 1;
        /* 轮播图占满整个宽度 */
        min-height: 300px;
    }

    .user-info-container {
        display: none;
        /* 隐藏用户信息 */
    }
}

@media (min-width: 769px) and (max-width: 1024px) {

    /* 平板端 */
    .course-list-container {
        max-width: 250px;
        /* 缩小课程列表宽度 */
    }

    .carousel-container {
        flex: 2;
        /* 轮播图占 2 份 */
    }

    .user-info-container {
        max-width: 200px;
        /* 缩小用户信息宽度 */
        
    }
}

@media (min-width: 1025px) {

    /* PC 端 */
    .course-list-container {
        max-width: 300px;
        /* 恢复课程列表宽度 */
    }

    .carousel-container {
        flex: 3;
        /* 轮播图占 3 份 */
    }

    .user-info-container {
        max-width: 400px;
        /* 恢复用户信息宽度 */
    }
}
</style>